import React from 'react';
import { useTranslation } from 'react-i18next';

import { SignalStatistic } from 'dashboard/hooks/useSignalStatistics';

import * as RechartsStyled from 'dashboard/styles/Recharts.style';

interface BehaviourTooltipProps {
  active?: boolean;
  payload?: { payload: SignalStatistic }[];
}

export default function BehaviourTooltip({
  active,
  payload,
}: BehaviourTooltipProps): JSX.Element | null {
  const { t } = useTranslation('pageDashboard');

  if (!active || !payload?.length) return null;

  const signal = payload[0].payload;

  return (
    <RechartsStyled.Tooltip>
      <RechartsStyled.TooltipTitle>{signal.signal}</RechartsStyled.TooltipTitle>
      <RechartsStyled.TooltipSubtitle>
        {t('behaviours.occurrences', { count: signal.count })}
      </RechartsStyled.TooltipSubtitle>
    </RechartsStyled.Tooltip>
  );
}
